import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery, UseMutationResult, useMutation } from 'react-query';

import {
  ReleaseAppSharedService,
  // eslint-disable-next-line camelcase
  PagedResultDto_ReleaseDetailDto,
} from '../../services/wealthlane-award-services';
import { isEmpty } from 'lodash';

const useGetTransactionReleaseVestingList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterData: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | PagedResultDto_ReleaseDetailDto
  | undefined,
  unknown
> => {
  // const {
  //   grantName,
  //   awardTypeId,
  //   createdFromDate: fromDate,
  //   createdToDate: toDate,
  //   settlementTypeIds,
  // } = filterData;
  const {
    filter: searchKeyWord,
    sorting,
    skipCount,
    maxResultCount,
    grantName,
    awardTypeId,
    createdFromDate: fromDate,
    createdToDate: toDate,
    settlementTypeIds,
    _force,
  } = tableInfo;

  const transactionReleaseVestingList = useQuery(
    [
      'getTransactionReleaseRsuVestingList',
      searchKeyWord,
      sorting,
      skipCount,
      maxResultCount,
      grantName,
      awardTypeId,
      fromDate,
      toDate,
      settlementTypeIds,
      _force,
    ],

    async () => {
      if (
        !isEmpty(searchKeyWord) ||
        !isEmpty(grantName) ||
        !isEmpty(awardTypeId) ||
        !isEmpty(fromDate) ||
        !isEmpty(toDate) ||
        !isEmpty(settlementTypeIds)
      ) {
        return await handleRequest(
          ReleaseAppSharedService.getApiAwardApiAppReleaseVestingList(
            sorting,
            skipCount,
            maxResultCount,
            searchKeyWord,
            grantName as string,
            awardTypeId,
            fromDate,
            toDate,
            settlementTypeIds
          )
        );
      }
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
    }
  );

  return transactionReleaseVestingList;
};

export default useGetTransactionReleaseVestingList;
